(function () {
	function init(card) {
		if (card.dataset.concoursCardInit === "1") return;
		card.dataset.concoursCardInit = "1";
		var btn = card.querySelector(".concours-card__btn");
		var step = card.querySelector(".concours-card_hidden-step");
		if (!btn || !step) return;

		btn.setAttribute("aria-expanded", "false");

		function toggle() {
			var willOpen = !card.classList.contains("is-open");
			if (willOpen) {
				document
					.querySelectorAll(".concours-card.is-open")
					.forEach(function (other) {
						if (other !== card) {
							other.classList.remove("is-open");
							var otherBtn = other.querySelector(
								".concours-card__btn"
							);
							if (otherBtn)
								otherBtn.setAttribute("aria-expanded", "false");
						}
					});
			}
			card.classList.toggle("is-open", willOpen);
			btn.setAttribute("aria-expanded", willOpen ? "true" : "false");
			if (willOpen) {
				requestAnimationFrame(function () {
					var rem =
						parseFloat(
							getComputedStyle(document.documentElement).fontSize
						) || 16;
					var top =
						card.getBoundingClientRect().top +
						window.pageYOffset -
						5 * rem;
					window.scrollTo({ top: top, behavior: "auto" });
				});
			}
		}

		var triggers = [card.querySelector(".concours-card__starter")];

		triggers.forEach(function (el) {
			if (!el) return;
			el.style.cursor = "pointer";
			el.addEventListener("click", toggle);
		});

		card.querySelectorAll(
			".concours-card__slider .concours-slider__arrow, .concours-card__slider .concours-slider__thumb"
		).forEach(function (el) {
			el.addEventListener("click", function (e) {
				e.stopPropagation();
				if (!card.classList.contains("is-open")) {
					e.preventDefault();
				}
			});
		});

		var addBtn = card.querySelector("[data-add-to-cart]");
		if (addBtn) {
			addBtn.addEventListener("click", function (e) {
				e.preventDefault();
				if (addBtn.disabled) return;

				var checked = card.querySelector(
					".concours-size-item__radio:checked"
				);
				var sizeError = card.querySelector("[data-size-error]");
				var hasSizeGrid = !!card.querySelector(".concours-size-grid");
				var variantId = checked
					? checked.getAttribute("data-variant-id")
					: hasSizeGrid
						? null
						: addBtn.getAttribute("data-default-variant-id");

				if (!variantId) {
					if (sizeError) sizeError.hidden = false;
					return;
				}
				if (sizeError) sizeError.hidden = true;

				addBtn.disabled = true;

				var cartDrawer = document.querySelector("cart-drawer");
				var body = {
					items: [{ id: parseInt(variantId, 10), quantity: 1 }],
				};
				if (
					cartDrawer &&
					typeof cartDrawer.getSectionsToRender === "function"
				) {
					body.sections = cartDrawer
						.getSectionsToRender()
						.map(function (s) {
							return s.id;
						});
					body.sections_url = window.location.pathname;
				}

				fetch(
					(window.routes && window.routes.cart_add_url) ||
						"/cart/add.js",
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Accept: "application/javascript",
						},
						body: JSON.stringify(body),
					}
				)
					.then(function (r) {
						if (!r.ok) throw new Error("add failed");
						return r.json();
					})
					.then(function (response) {
						if (
							cartDrawer &&
							typeof cartDrawer.renderContents === "function"
						) {
							if (cartDrawer.classList.contains("is-empty")) {
								cartDrawer.classList.remove("is-empty");
							}
							cartDrawer.renderContents(response);
						} else {
							window.location.href = "/cart";
						}
					})
					.catch(function () {
						alert("Erreur lors de l'ajout au panier.");
					})
					.finally(function () {
						addBtn.disabled = false;
					});
			});
		}
	}

	document.querySelectorAll(".concours-card").forEach(init);

	var drawer = document.querySelector("[data-size-guide-drawer]");
	if (drawer) {
		var img = drawer.querySelector("[data-size-guide-img]");
		var titleEl = drawer.querySelector("[data-size-guide-title]");

		function openDrawer(src, title) {
			img.src = src;
			if (title) titleEl.textContent = title;
			drawer.hidden = false;
			requestAnimationFrame(function () {
				drawer.classList.add("is-open");
			});
		}

		function closeDrawer() {
			drawer.classList.remove("is-open");
			setTimeout(function () {
				drawer.hidden = true;
			}, 300);
		}

		document.addEventListener("click", function (e) {
			var trigger = e.target.closest("[data-size-guide]");
			if (trigger) {
				e.preventDefault();
				e.stopPropagation();
				openDrawer(
					trigger.getAttribute("data-size-guide"),
					trigger.getAttribute("data-size-guide-title")
				);
				return;
			}
			if (e.target.closest("[data-size-guide-close]")) {
				closeDrawer();
			}
		});

		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape") closeDrawer();
		});
	}
})();
